import initNotes from './init_notes';

// this module is required for the EE functions to work properly with merge request tabs
export default () => {
  initNotes();
};
